import React from "react";
import { Link } from "react-router-dom";
import "./WelcomePage.css";

const WelcomePage = () => {
  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <h1>Vending Management System</h1>
        <p>Welcome to the stock management dashboard</p>
        
        <div className="nav-links">
          <Link to="/view-all-stock" className="nav-button">
            📦 View All Stock
          </Link>
        </div>
        
        <p className="info-text">Select an option above to get started</p>
      </div>
    </div>
  );
};

export default WelcomePage;
